/**
 * Get the variant names of an enum as an array
 */
export function enumKeys<T extends object>(e: T): (keyof T)[] {
  return Object.keys(e).filter((item) => {
    return Number.isNaN(Number(item));
  }) as (keyof T)[];
}

export function enumValues<T extends Record<string, any>, G extends keyof T = keyof T>(e: T): T[G][] {
  const keys = enumKeys(e);
  return keys.map((k) => e[k]) as any;
}

/**
 * Converts a string to an enum value.
 * If the string is not a valid enum value, it returns the fallback value.
 * @param value - The string to convert.
 * @param validValues - The list of valid enum values to match against.
 * @param fallback - The fallback value to return if no match is found.
 * @returns The matching enum value or the fallback.
 */
export function toEnumValue<T extends string | number>(value: string, validValues: T[], fallback: T): T {
  // Check if the value exists in the list of valid values
  return validValues.includes(value as T) ? (value as T) : fallback;
}
